import type { RequestOptions } from "ls/api/common/server";
import type { UrlMetadata } from "./urlMetadata.types";
import { server } from "./server";

export async function getUrlMetadata(url: string, { signal }: RequestOptions = {}) {
  if (url == null || url.trim() === "") {
    throw new Error("Can't fetch metadata. URL is empty");
  }

  const response = await server.get("url-metadata", {
    searchParams: {
      url,
    },
    signal,
  });
  return await response.json() as UrlMetadata;
}
